/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import ActivitiesIcon from 'icons/ActivitiesIcon';

const messages = defineMessages({
  title: {id: 'navigation.activities'},
});

const ActivitiesItem = () => (
  <RouteLinkItem
    iconBefore={ActivitiesIcon}
    route="midas/students/activities"
    title={messages.title}
  />
);

export default ActivitiesItem;
